import { API } from "../api";

const BASE = "/cooperatives/subscription";

/**
 * Plan status and renewal for a cooperative. These calls must work while the plan is expired, so the
 * backend keeps them outside the check.subscription gate (see the backend handover).
 */
export const subscriptionApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.query({
      query: () => ({ url: `${BASE}?guard=staff` }),
      transformResponse: (responseData) => responseData?.data,
    }),

    startSubscriptionRenewal: builder.mutation({
      query: ({ plan_id, callback_url }) => ({
        url: `${BASE}/renew?guard=staff`,
        method: "POST",
        body: { plan_id, callback_url },
      }),
      transformResponse: (responseData) => responseData?.data,
    }),

    verifySubscriptionRenewal: builder.mutation({
      query: (reference) => ({
        url: `${BASE}/renew/verify?guard=staff&reference=${encodeURIComponent(reference)}`,
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
    }),
  }),
});

export const {
  useGetSubscriptionQuery,
  useStartSubscriptionRenewalMutation,
  useVerifySubscriptionRenewalMutation,
} = subscriptionApi;
